import React from "react";
import DoctorSettings from "../DoctorSettings/DoctorSettings";
import useHospitalProviderRole from "./useHospitalProviderRole";

export default function HospitalSettings() {
  useHospitalProviderRole();
  return <DoctorSettings />;
}
